import axios from "axios";
import { BASE_URL } from "../../constant/staticUrl";
import axiosInstance from "../../utils/axiosInstance";
const API = axios.create({ baseURL: BASE_URL });



export const getLectureNoApi = (data) =>
  axiosInstance.post("/admin/live-class/get-lecture-no", data);
